<template>
	<transition :name="`carousel-${transitionName}`" tag="div" appear>
		<div :key="selectedIndex" class="carousel">
			<!-- <div class="carousel-img" :style="{ backgroundImage: `url(${cdnHost}${preview.bannerImage})` }"></div> -->
			<div class="carousel-img"><cdnImage :src="preview.bannerImage" /></div>
			<div class="shadow left"></div>
			<div class="shadow right"></div>
			<div class="shadow bottom"></div>
			<div class="content">
				<div v-if="previewGameLogo" class="game-logo">
					<cdnImage :src="previewGameLogo" />
				</div>
				<div class="game-info" :class="{ nologo: !previewGameLogo }">
					<div class="title">{{ getLocaleString(preview.title) }}</div>
					<div class="subtitle">{{ getLocaleString(preview.subTitle) }}</div>
					<FormButton :label="getLocaleString(preview.buttonText)" :button-click="clickHeroBannerBtn"></FormButton>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { mapState } from 'vuex';
import { getEnglishOrLocaleString, getLocaleString } from '../../../plugins/helpers';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
// polyfills
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import cdnImage from '@/components/cdn-image';
import { FormButton } from '@arena/toolkit';

export default {
	name: 'Carousel',
	components: {
		FormButton,
		cdnImage,
	},
	props: {
		selectedIndex: {
			type: Number,
			default: 0,
		},
		previousSelectedIndex: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {};
	},
	computed: {
		...mapState(['heroBannerList', 'gameList']),
		preview() {
			return this.heroBannerList[this.selectedIndex];
		},
		transitionName() {
			return this.selectedIndex >= this.previousSelectedIndex ? 'next' : 'previous';
		},
		language() {
			return this.$i18n.locale;
		},
		previewGameLogo() {
			const matchedGame = this.gameList.find((game) => game.productID === this.preview.productId);
			return matchedGame ? matchedGame.gameLogo : '';
		},
	},
	methods: {
		clickHeroBannerBtn() {
			dataLayer.push({
				event: 'Hero CTA Click',
				heroCTAType: getEnglishOrLocaleString(this.preview.buttonText, this.language),
				heroGameName: this.preview.productName,
				heroGameID: this.preview.productId,
			});
			window.open(this.appendArenaSidQS(this.getLocaleString(this.preview.buttonLink)), '_blank');
		},
		getLocaleString(data) {
			return getLocaleString(data, this.language);
		},
	},
};
</script>

<style lang="less" scoped>
.carousel-next-enter-active,
.carousel-next-leave-active,
.carousel-previous-leave-active,
.carousel-previous-enter-active {
	transition: all 1s;
}
.carousel-next-enter {
	opacity: 0;
	transform: translateX(50px);
}
.carousel-previous-enter {
	opacity: 0;
	transform: translate(-50px);
}

.carousel {
	bottom: 0;
	height: 100%;
	left: 0;
	margin: auto;
	position: absolute;
	right: 0;
	top: 0;
	white-space: nowrap;
	width: 100%;
	.carousel-img {
		background-position: center;
		background-size: cover;
		height: 331px;
		width: 100%;
		overflow: hidden;
	}
	.shadow {
		position: absolute;
		display: none;
		&.bottom {
			background: url('~@/images/hero-banner/shadows/bottom_375.png') no-repeat center;
			bottom: 0;
			display: block;
			height: 300px;
			width: 100%;
		}
	}
	.content {
		align-items: center;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: flex-end;
		left: 0;
		margin: auto;
		padding-bottom: 48px;
		position: absolute;
		right: 0;
		top: 0;
		width: 100%;
		.game-logo {
			height: 73px;
			position: relative;
			width: 100%;
		}
		.game-info {
			align-items: center;
			display: flex;
			flex-direction: column;
			max-width: 335px;
			white-space: pre-wrap;
			&.nologo {
				margin-bottom: 25px;
			}
			.title {
				color: white;
				display: none;
				font-family: Roboto;
				font-size: 37.5px;
				font-weight: bold;
				letter-spacing: -0.75px;
				line-height: 1.19;
				margin-bottom: 15px;
				text-align: center;
			}
			.subtitle {
				color: rgba(255, 255, 255, 1);
				font-size: 14px;
				letter-spacing: -0.28px;
				line-height: 1.57;
				opacity: 0.7;
				text-align: center;
				width: 100%;
			}
			button {
				background-color: #151517;
				border: 1px solid rgba(255, 255, 255, 0.5);
				border-radius: 5px;
				color: rgba(255, 255, 255, 1);
				font-size: 12px;
				height: 46px;
				margin-top: 25px;
				padding: 0 35px;
				width: auto;
				&:hover {
					border: 1px solid rgba(255, 255, 255, 1);
				}
				&:active {
					border: 1px solid rgba(255, 255, 255, 0.2);
					color: rgba(255, 255, 255, 0.2);
				}
			}
		}
	}
}

@media (min-width: 548px) {
	.carousel {
		.content {
			.game-info {
				max-width: 507px;
			}
		}
	}
}

@media (min-width: 768px) {
	.carousel {
		.carousel-img {
			height: 441px;
		}
		.shadow.bottom {
			background: url('~@/images/hero-banner/shadows/bottom_768.png') no-repeat top;
			height: 340px;
		}
		.content {
			padding-bottom: 49px;
			.game-logo {
				height: 104px;
			}
			.game-info {
				padding: 0 110px;
				max-width: 100%;
				&.nologo {
					margin-bottom: 50px;
				}
				.title {
					display: block;
				}
				.subtitle {
					padding: 0 40px;
				}
			}
		}
	}
}

@media (min-width: 1024px) {
	.carousel {
		width: 1024px;
		.carousel-img {
			height: 100%;
			position: absolute;
			right: 0;
			width: 813px;
		}
		.shadow {
			display: block;
			&.left {
				background: url('~@/images/hero-banner/shadows/left.png') no-repeat top;
				background-size: cover;
				height: 100%;
				width: 589px;
			}
			&.right {
				background: url('~@/images/hero-banner/shadows/right.png') no-repeat top;
				background-size: cover;
				height: 100%;
				right: 0;
				width: 223px;
			}
			&.bottom {
				background: url('~@/images/hero-banner/shadows/bottom_1920.png') no-repeat top;
				background-size: cover;
				height: 94px;
			}
		}
		.content {
			align-items: flex-start;
			justify-content: center;
			padding-bottom: 7px;
			width: 766px;
			.game-logo {
				height: 54px;
				margin: 0 0 15px;
				width: auto;
			}
			.game-info {
				align-items: flex-start;
				padding: 0;
				.title {
					font-size: 29px;
					letter-spacing: -0.58px;
					line-height: 1.14;
					margin-bottom: 10px;
					text-align: left;
					width: 225px;
				}
				.subtitle {
					color: #a8a8a8;
					font-size: 12px;
					letter-spacing: -0.24px;
					line-height: 1.67;
					padding: 0;
					text-align: left;
					width: 320px;
				}
				button {
					font-size: 10px;
					height: 36px;
					margin-top: 18px;
					padding: 0 23px;
				}
			}
		}
	}
}

@media (min-width: 1280px) {
	.carousel {
		width: 1280px;
		.carousel-img {
			width: 1022px;
		}
		.shadow {
			&.left {
				width: 738px;
			}
			&.right {
				width: 278px;
			}
			&.bottom {
				height: 118px;
			}
		}
		.content {
			padding-bottom: 80px;
			width: 961px;
			.game-info {
				.title {
					width: 300px;
				}
			}
		}
	}
}

@media (min-width: 1440px) {
	.carousel {
		width: 1440px;
		.carousel-img {
			width: 1148px;
		}
		.shadow {
			&.left {
				width: 830px;
			}
			&.right {
				width: 314px;
			}
			&.bottom {
				height: 133px;
			}
		}
		.content {
			padding-bottom: 91px;
			width: 1080px;
			.game-logo {
				height: 63px;
			}
			.game-info {
				.title {
					font-size: 33px;
					letter-spacing: -0.66px;
					line-height: 1.29;
					width: 250px;
				}
				.subtitle {
					font-size: 14px;
					letter-spacing: -0.28px;
					line-height: 1.43;
					width: 380px;
				}
				button {
					font-size: 12px;
					height: 46px;
					padding: 0 35px;
				}
			}
		}
	}
}

@media (min-width: 1600px) {
	.carousel {
		width: 1600px;
		.carousel-img {
			width: 1292px;
		}
		.shadow {
			&.left {
				width: 911px;
			}
			&.right {
				width: 355px;
			}
			&.bottom {
				height: 150px;
			}
		}
		.content {
			padding-bottom: 101px;
			width: 1200px;
			.game-logo {
				height: 103px;
			}
			.game-info {
				.title {
					font-size: 37.5px;
					line-height: 1.19;
					letter-spacing: -0.75px;
					width: 275px;
				}
				.subtitle {
					color: rgba(255, 255, 255, 0.7);
					line-height: 1.57;
				}
			}
		}
	}
}

@media (min-width: 1920px) {
	.carousel {
		width: 1920px;
		.carousel-img {
			width: 1530px;
		}
		.shadow {
			&.left {
				width: 1106px;
			}
			&.right {
				width: 419px;
			}
			&.bottom {
				height: 177px;
			}
		}
		.content {
			padding-bottom: 120px;
			width: 1440px;
		}
	}
}
</style>
